export var BackgroundType;
(function(BackgroundType) {
    BackgroundType["NONE"] = 'none';
    BackgroundType["SOLID"] = 'solid';
    BackgroundType["GRADIENT"] = 'gradient';
    BackgroundType["PATTERN"] = 'pattern';
    BackgroundType["IMAGE"] = 'image';
    BackgroundType[// templates
    "TEMPLATE_1"] = 'template_1';
    BackgroundType["TEMPLATE_2"] = 'template_2';
    BackgroundType["TEMPLATE_3"] = 'template_3';
    BackgroundType["TEMPLATE_4"] = 'template_4';
    BackgroundType["TEMPLATE_5"] = 'template_5';
    BackgroundType["TEMPLATE_6"] = 'template_6';
    BackgroundType["TEMPLATE_7"] = 'template_7';
    BackgroundType["TEMPLATE_8"] = 'template_8';
    BackgroundType["TEMPLATE_9"] = 'template_9';
    BackgroundType["TEMPLATE_10"] = 'template_10';
    BackgroundType["TEMPLATE_11"] = 'template_11';
    BackgroundType["TEMPLATE_12"] = 'template_12';
    BackgroundType["TEMPLATE_13"] = 'template_13';
    BackgroundType["TEMPLATE_14"] = 'template_14';
})(BackgroundType || (BackgroundType = {}));
export var BackgroundImageDisplayMode;
(function(BackgroundImageDisplayMode) {
    BackgroundImageDisplayMode["TILE"] = 'tile';
    BackgroundImageDisplayMode["COVER"] = 'cover';
    BackgroundImageDisplayMode["CONTAIN"] = 'contain';
})(BackgroundImageDisplayMode || (BackgroundImageDisplayMode = {}));
